module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "id": "modal-troca-app",
      "size": _vm.aplicacoes.length <= 2 ? 'modal-md' : 'modal-lg',
      "data-backdrop": "static",
      "tabindex": "-1",
      "closable": true,
      "closeFunction": _vm.closeModal
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.closeModal.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "page-title",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('trocaApp.titulos.titulo'))
    }
  }), _c('h4', {
    staticClass: "subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('trocaApp.titulos.subtitulo'))
    }
  })]), _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, _vm._l((_vm.aplicacoes), function(app) {
    return _c('button-application', {
      key: app.id,
      attrs: {
        "data": app,
        "btnDesc": app.descricao,
        "btnImg": app.imagem,
        "btnActive": app.active,
        "btnClickFunction": app.click,
        "btnWidth": _vm.calcWidth(app),
        "btnAppId": app.id
      }
    })
  }), 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-72f81e1a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72f81e1a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/modals/changeApplicationModal/changeApplicationModal.pug
// module id = 1434
// module chunks = 0